<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item :label="$t('dms_device_comp_edit_dialog.ying_jian_ban_ben')" prop="hwVersion">
          <el-input v-model="form.hwVersion" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        // 硬件版本
        hwVersion: '',
      },
    };
  },
  mounted() {
    this.init();
  },

  computed: {
    rules() {
      return {
        hwVersion: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.$setFormatData(this.form, this.model.data);
    },
    onConfirm() {
      this.$refs.form.validate((validate) => {
        if (validate) {
          this.onEdit();
        }
      });
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    },
    onEdit() {
      const reqData = {
        bodyNum: this.model.data.bodyNum,
        hwVersion: this.form.hwVersion,
      };
      this.$postJSON(apis.deviceStructureHwVersionUpdate, reqData).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_edit_success'),
        });
        this.$emit('success');
        this.close();
      });
    },
  },
};
</script>

<style lang="scss"></style>
